export const DRAWERS_PARAM_NAME = "d"

export const CODE_REPOSITORY_DRAWER_ID = "b"

export const APPLICATION_DRAWER_ID = "a"

export const IMAGE_DRAWER_ID = "i"

export const TRIAGE_DRAWER_ID = "g"

export const PACKAGE_DRAWER_ID = "p"

export const VIRTUAL_MACHINE_DRAWER_ID = "v"

export const THREAT_DRAWER_ID = "t"

export const QUICK_WINS_DRAWER_ID = "q"

export const AGENT_AI_DISCOVERY_DRAWER_ID = "z"

export const WORKFLOW_AI_DISCOVERY_DRAWER_ID = "x"

// One AI policy's violations
export const AI_POLICY_VIOLATIONS_DRAWER_ID = "w"

export const WIDTH_DEFAULT = 1100

export const TAB_NAMES = {
  attackScenarios: "attackScenarios",
  runtimeEvidence: "runtimeEvidence",
  agents: "agents",
  exploitValidation: "exploitValidation",
  remediation: "remediation"
}
